/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Product_Not_FoundInputs */

const vi_error_product_not_found = /** @type {(inputs: Error_Product_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm không còn tồn tại hoặc đã bị xoá.`)
};

/**

* @param {Error_Product_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_not_found = /** @type {((inputs?: Error_Product_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_not_found(inputs)
});